import './Leads.scss';
import React from 'react';
import queryString from 'query-string';
import cookie from 'js-cookie';
import {NavLink as Link} from 'react-router-dom';
import withRouter from '/src/components/misc/withRouter';
import dealers from '../../../../model/dealer';
import leadsModel from '../../../../model/leads';
import Loading from '../misc/Loading';

export const leadTypes = {
  Campaign: 'Kampanje',
  CarConfiguratorOffer: 'Bilkonfigurator',
  DealerContact: 'Kontakt forhandler',
  TestDrive: 'Prøvekjøring',
  Workshop: 'Verksted',
  CarQuestion: 'Spørsmål om bil',
  DigitalConsulting: 'Digital konsultasjon',
  CarParts: 'Deler og utstyr',
  ProductImprovement: 'Produktforbedring',
  Reservation: 'Reservasjon',
  Custom: 'Egendefinerte skjemaer'
};

class LeadsList extends React.Component {
  constructor(props) {
    super(props);

    this.limit = 20;
    this.offset = 0;
    this.total = null;

    this.state = {
      leads: [],
      dealers: {},
      messages: {}
    };

    this.makes = [
      {
        id: 'mitsubishi',
        name: 'Mitsubishi'
      },
      {
        id: 'renault',
        name: 'Renault'
      },
      {
        id: 'dacia',
        name: 'Dacia'
      },
      {
        id: 'hongqi',
        name: 'Hongqi'
      },
      {
        id: 'dongfeng',
        name: 'Dongfeng'
      },
      {
        id: 'voyah',
        name: 'Voyah'
      },
      {
        id: 'changan',
        name: 'Changan'
      }
    ];

    this.setOffset = this.setOffset.bind(this);
    this.setTypeFilter = this.setTypeFilter.bind(this);
  }

  UNSAFE_componentWillMount() { // eslint-disable-line camelcase
    document.title = 'Admin - Leads';
    const query = queryString.parse(this.props.location.search);
    if (query) {
      if (query.page && query.page > 0) {
        this.offset = (query.page - 1) * this.limit;
      }

      if (query.filter) {
        this.filter = query.filter;
      }
    }

    if (query && query.make) {
      this.make = query.make;
    } else {
      const cookiefilter = cookie.get('mgLeadMakeFilter');

      if (cookiefilter !== 'null') { // null is string in this case
        this.make = cookiefilter;
      }
    }

    dealers.all().then((dealers) => {
      const dealersIndexed = {};

      for (let i = 0; i < dealers.length; ++i) {
        dealersIndexed[dealers[i].id] = dealers[i];
      }

      this.setState({
        dealers: dealersIndexed
      });
    });

    this.fetchLeads(this.offset, this.limit, this.filter, this.make);
  }

  fetchLeads(offset, limit, filter, make) {
    this.setState({
      leads: []
    }, () => {
      leadsModel.all(offset, limit, filter, make).then(([leads, total]) => {
        this.total = total;
        this.setState({
          leads: leads
        });
      }).catch((error) => {
        console.error(error);
        this.setState({
          messages: {
            error: {
              title: 'Feil ved henting av leads',
              message: 'Er services startet og tilgjengelig?'
            }
          }
        });
      });
    });
  }

  setTypeFilter(e, type) {
    e.preventDefault();

    this.props.history.replace({
      pathname: '/leads',
      search: queryString.stringify({
        page: Math.floor(this.offset / this.limit) + 1,
        filter: type,
        make: this.make
      })
    });

    this.filter = type;
    this.fetchLeads(this.offset, this.limit, this.filter, this.make);
  }

  setMakeFilter(e, make) {
    e.preventDefault();

    this.props.history.replace({
      pathname: '/leads',
      search: queryString.stringify({
        page: Math.floor(this.offset / this.limit) + 1,
        filter: this.filter,
        make: make
      })
    });

    cookie.set('mgLeadMakeFilter', make, {path: '/'});

    this.make = make;
    this.fetchLeads(this.offset, this.limit, this.filter, this.make);
  }

  setOffset(e, offset) {
    e.preventDefault();

    this.props.history.replace({
      pathname: '/leads',
      search: queryString.stringify({
        page: Math.floor(offset / this.limit) + 1,
        filter: this.filter,
        make: this.make
      })
    });

    this.offset = offset;
    this.fetchLeads(this.offset, this.limit, this.filter, this.make);
  }

  gotoLead(id) {
    this.props.history.push(`/leads/lead/${id}`);
  }

  printMessages() {
    if (this.state.messages.error) {
      return <div className="alert alert-danger"><strong>{this.state.messages.error.title}</strong> {this.state.messages.error.message}</div>;
    }
  }

  printTypeFilterButton() {
    const boxFilterBtnDisabled = this.state.leads.length === 0 && this.filter === '';

    return (
      <div className="btn-group" role="group">
        <div className="dropdown">
          <button type="button"
            data-toggle="dropdown"
            className={`btn btn-default dropdown-toggle${boxFilterBtnDisabled ? ' disabled' : ''}`}
            disabled={boxFilterBtnDisabled}
          >
            Type: <strong>{this.filter ? (leadTypes[this.filter] || this.filter) : 'Alle'}</strong> <span className="caret"></span>
          </button>
          <ul className="dropdown-menu" >
            <li className={this.filter === '' ? 'active' : ''}><a href="#" onClick={(e) => this.setTypeFilter(e, '')}>Alle</a></li>
            <li role="separator" className="divider"></li>
            {Object.keys(leadTypes).map((type, i) => {
              return (
                <li key={i} className={this.filter === type ? 'active' : ''}><a href="#" onClick={(e) => this.setTypeFilter(e, type)}>{leadTypes[type]}</a></li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }

  printMakeFilterButton() {
    const boxFilterBtnDisabled = this.state.leads.length === 0 && this.make === '';

    return (
      <div className="btn-group" role="group">
        <div className="dropdown">
          <button
            type="button"
            data-toggle="dropdown"
            className={`btn btn-default dropdown-toggle${boxFilterBtnDisabled ? ' disabled' : ''}`}
            disabled={boxFilterBtnDisabled}
          >
            Merke: <strong>{this.make || 'Alle'}</strong> <span className="caret"></span>
          </button>
          <ul className="dropdown-menu" >
            <li className={this.make === '' ? 'active' : ''}>
              <a href="#" onClick={(e) => this.setMakeFilter(e, '')}>
                Alle
              </a>
            </li>
            <li role="separator" className="divider"></li>
            {this.makes.map((make, i) => {
              return (
                <li key={`make-${i}`} className={this.make === make.id ? 'active' : ''}>
                  <a href="#" onClick={(e) => this.setMakeFilter(e, make.id)}>
                    {make.name}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }

  printToolbar() {
    if (this.state.messages.error) {
      return;
    }

    return (
      <div className="btn-toolbar" role="toolbar">
        {this.printTypeFilterButton()}
        {this.printMakeFilterButton()}
      </div>
    );
  }

  printPager() {
    if (!this.state.leads.length) {
      return;
    }

    if (!this.total || this.total <= this.limit) {
      return;
    }

    const pages = Math.ceil(this.total / this.limit);
    const offsets = [];

    for (let i = 0; i < pages; i++) {
      offsets.push(i * this.limit);
    }

    const pagingSpan = 10;
    const currentPageNumber = (this.offset > 0) ? ((this.offset / this.limit) + 1) : this.offset;
    const pagingMinValue = (currentPageNumber > pagingSpan) ? (currentPageNumber - pagingSpan) : 0;
    const pagingMaxValue = pagingMinValue + pagingSpan;

    const lastOffset = offsets[offsets.length - 1];

    if (this.total && this.total > this.limit) {
      return <ul className="pagination">
        <li className={this.offset > 0 ? '' : 'disabled'}>
          <a href="#" onClick={(e) => this.setOffset(e, 0)} aria-label="First">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>

        {offsets.map((offset, i) => {
          if (i < pagingMaxValue && i >= pagingMinValue) {
            return <li key={i} className={this.offset === offset ? 'active' : ''}>
              <a href="#" onClick={(e) => this.setOffset(e, offset)}>
                {i + 1}
              </a>
            </li>;
          } else if (i === pagingMaxValue) {
            return <li key={i}><a onClick={(e) => this.setOffset(e, offset)}> ... </a></li>;
          }
          return '';
        })}

        <li className={(this.offset + this.limit) > this.total ? 'disabled' : ''}>
          <a href="#" onClick={(e) => this.setOffset(e, lastOffset)} aria-label="Last">
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>;
    }
  }

  render() {
    if (!this.state.dealers) {
      return (
        <Loading title="Leads" text="Laster leads"/>
      );
    }

    return (
      <section>
        <div className="row">
          <div className="col-lg-12">
            <h1 className="page-header">Leads <small>(<Link to="/leads/test">Skjema test</Link>)</small></h1>
            {this.printMessages()}
            {this.printToolbar()}
            <br />
            <table className="table table-striped table-bordered table-hover mg-table-leads">
              <thead>
                <tr>
                  <th>Opprettet</th>
                  <th>Innsendt fra (referer)</th>
                  <th>Type skjema</th>
                  <th>Status</th>
                  <th>Forhandler</th>
                </tr>
              </thead>
              <tbody>
                {this.state.leads.map((lead, i) => {
                  const leadSuccessful = lead.success;
                  const leadIgnored = lead.ignore;
                  const leadOk = leadSuccessful || (!leadSuccessful && leadIgnored);

                  return (
                    <tr key={i} onClick={() => this.gotoLead(lead.id)}>
                      <td>
                        <Link onClick={(e) => e.preventDefault()} to={`/leads/lead/${lead.id}`}>{new Date(lead.created * 1000).toLocaleString()}</Link>
                      </td>
                      <td>
                        <span>{lead.formData.referer}</span>
                      </td>
                      <td>
                        {leadTypes[lead.type] || lead.type}
                      </td>
                      <td>
                        <span className={leadOk ? 'text-success' : 'text-danger'}>{leadSuccessful ? 'OK' : 'Feilet'}</span> {leadIgnored ? ' (Ignorert)' : ''}
                      </td>
                      <td>
                        {this.state.dealers[lead.dealerRef] ? this.state.dealers[lead.dealerRef].name : lead.dealerRef}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 text-center">
            {this.printPager()}
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(LeadsList);
